import { render, staticRenderFns } from "./TargetContentLocationNew.vue?vue&type=template&id=6989ece0&scoped=true&"
import script from "./TargetContentLocationNew.vue?vue&type=script&lang=ts&"
export * from "./TargetContentLocationNew.vue?vue&type=script&lang=ts&"
import style0 from "./TargetContentLocationNew.vue?vue&type=style&index=0&id=6989ece0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989ece0",
  null
  
)

export default component.exports